import React, {FC} from "react"
import styled from "styled-components"

import {iconPicker, isChevron} from "./helpers"
import IconTypes from "./IconTypes.enum"
import {SpacingProps} from "../global/css"

export interface IconProps extends SpacingProps {
  icon: IconTypes
  id?: string
  size?: number
  color?: string
  small?: boolean
  large?: boolean
  extraLarge?: boolean
  block?: boolean
  strokeWidth?: number
}

const IconComponent: FC<IconProps> = (props) => {
  const {extraLarge, large, small, size, icon, block, ...rest} = props

  // by default, Icons follow same dimensions as fonts in buttons
  let iconSize = 16
  const display = block ? "block" : "inline"

  if (large) iconSize = 18
  if (extraLarge) iconSize = 20
  if (small) iconSize = 14

  // if the icon is a chevron, we want it to look smaller than the other icons
  if (isChevron(icon)) iconSize -= 6

  if (size) iconSize = size

  const Icon = iconPicker(icon)
  return <Icon display={display} size={iconSize} {...rest} />
}

export default styled(IconComponent)``
export {default as IconTypes} from "./IconTypes.enum"
